// Topbar-Steuerung je Viewport (G1) — welche rechten Aktions-Elemente die
// Topbar in NavigationLayout rendert. Bewusst React-frei, damit die Logik im
// Vitest-„node"-Runner ohne DOM getestet werden kann (analog bottomBars.ts).
//
// Hintergrund: Auf dem Tablet (769–1024px) nahm die volle 280px-Such-Pille
// zusammen mit dem Telefon-/Schnellwahl-Button so viel Breite ein, dass der
// Header umbrach. Auf dem Tablet wird die Suche daher als kompaktes Icon
// dargestellt (die eigentliche Suchleiste = Command-Palette klappt erst auf
// Klick auf), und der Telefon-Button entfällt in der Topbar (bleibt über die
// Command-Palette „Telefon öffnen" bzw. das Sidebar-Menü erreichbar).
//
// Breakpoints (siehe hooks/useResponsive):
//   • Phone   (≤ 768px)        → keine Topbar-Suche / kein Telefon-Button
//                                 (Navigation läuft über den Overlay-Drawer).
//   • Tablet  (769 … 1024px)   → Such-Icon (Toggle → Command-Palette);
//                                 Telefon-Button entfällt.
//   • Desktop (> 1024px)       → volle Such-Pille + Telefon-Button (unverändert).

export interface TopbarViewportInput {
  /** ≤ 768px — echte Handys (useResponsive.isPhone). */
  isPhone: boolean;
  /** 769–1024px — Tablets (useResponsive.isTablet). */
  isTablet: boolean;
}

export interface TopbarControls {
  /** Volle Such-Pille (Desktop): 280px-Pille mit ⌘K-Kürzel. */
  showSearchPill: boolean;
  /** Kompaktes Such-Icon (Tablet): 38×38-Icon, das die globale Suche aufklappt. */
  showSearchIcon: boolean;
  /**
   * Telefon-/Schnellwahl-Button in der Topbar. Nur Desktop — auf dem Tablet
   * entfällt er (G1), damit der Header nicht bricht. Die eigentliche Sichtbarkeit
   * hängt zusätzlich am Recht `calls:read` (Prüfung bleibt in der Komponente).
   */
  showPhoneButton: boolean;
}

/**
 * Leitet aus den Viewport-Flags ab, welche rechten Topbar-Aktionen gerendert
 * werden. Genau EINE der beiden Such-Varianten ist je Nicht-Phone-Viewport aktiv
 * (Desktop → Pille, Tablet → Icon); auf dem Phone keine von beiden.
 */
export function computeTopbarControls(i: TopbarViewportInput): TopbarControls {
  // Desktop = weder Phone noch Tablet (> 1024px).
  const isDesktop = !i.isPhone && !i.isTablet;
  return {
    showSearchPill: isDesktop,
    showSearchIcon: i.isTablet,
    showPhoneButton: isDesktop,
  };
}
